import { ReactElement } from 'react';

import { faEllipsisVertical } from '@awesome.me/kit-379289146f/icons/classic/solid';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, ButtonProps, styled } from '@mui/material';

import { removeTheseProps } from '@/utils';

type StyledButtonProps = ButtonProps & {
  open: boolean;
};

const StyledButton = styled(Button, {
  shouldForwardProp: removeTheseProps<StyledButtonProps>('open'),
})<StyledButtonProps>(({ theme: { palette }, open }) => ({
  maxWidth: 32,
  minWidth: 32,
  border: '1px solid #828D98',
  color: '#828D98',
  backgroundColor: palette.common.white,
  '&:hover': {
    backgroundColor: palette.common.white,
    borderColor: palette.primary.main,
    color: palette.primary.main,
  },
  '&.Mui-disabled': {
    borderColor: palette.action.disabled,
  },
  outlineOffset: '2px',
  outline: open ? '2px solid #0175C9' : 'none',
  '&:focus': {
    outline: '2px solid #0175C9',
  },
}));

export const KebabHeaderButton = (
  props: Omit<StyledButtonProps, 'children'>,
): ReactElement => {
  return (
    <StyledButton aria-label="More Options" {...props}>
      <FontAwesomeIcon icon={faEllipsisVertical as IconProp} size="lg" />
    </StyledButton>
  );
};
